import React from 'react';
import { Section } from './shared';
import LearnerEngagement from './LearnerEngagement';
import GrowthTrends from './GrowthTrends';

/** `learners.segments` and `trends`, exported together as the `engagement` sheet. */
const EngagementAndGrowth = ({ learners = {}, trends = {} }) => (
  <Section id="engagement" title="Engagement and growth" exportKey="engagement">
    <LearnerEngagement data={learners} />
    <GrowthTrends data={trends} />
  </Section>
);

export default EngagementAndGrowth;
